import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/price.module.scss';

const Price = () => {
  return (
<div className={classNames(Style.price)}>
  <div className={classNames(Style.price__title)}>料金プラン</div>
  <div className={classNames(Style.price__content)}>
    <div className={classNames(Style.price__plan)}>
      スタンダード<br />プラン
    </div>
    <div className={classNames(Style.price__details)}>
      <div className={classNames(Style.price__section)}>
        <div className={classNames(Style.price__sectionTitle)}>カートシステム</div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>月額費用</div>
          <div className={classNames(Style.price__item__price)}>0円</div>
        </div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>初期費用</div>
          <div className={classNames(Style.price__item__price)}>0円</div>
        </div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>システム利用料*3</div>
          <div className={classNames(Style.price__item__price)}>3%</div>
        </div>
      </div>
      <div className={classNames(Style.price__section)}>
        <div className={classNames(Style.price__sectionTitle)}>クレジットカード決済*1</div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>月額費用*2</div>
          <div className={classNames(Style.price__item__price)}>0円</div>
        </div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>売上処理料*2</div>
          <div className={classNames(Style.price__item__price)}>0円</div>
        </div>
        <div className={classNames(Style.price__item)}>
          <div className={classNames(Style.price__item__label)}>決済手数料*4</div>
          <div className={classNames(Style.price__item__price)}>3.5%</div>
        </div>
      </div>
    </div>
  </div>
  <div className={classNames(Style.price__notes)}>
    <p>*1 クレジットカード決済は「株式会社ゼウス」のサービスです。クレジットカード決済の手数料は、支払方法としてクレジットカード決済を利用する場合のみ発生致します。その他、ご利用になられる決済手段に応じて、各決済サービスで定められた料金が発生致します。</p>
    <p>*2 上記の料金は、当社経由でのお申込みの場合、適応されます。</p>
    <p>*3 「システム利用料」は税込表示となります。各販売ごとの売上（送料及び消費税を含む）に対して3%発生致します。</p>
    <p>*4 「決済手数料」は税抜表示となります。クレジットカード決済の「決済手数料」は、1注文ごとに3.5%発生致します。</p>
  </div>
</div>
  );
};
export default Price;
